export default { sha: '023e52334aca55e25e8d20c0a31f98279c9021ba', buildNumber: 'undefined' }
